/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_sort_setting = {
  namespaced: true,
  actions: {

    update ({ commit }, { target_date, driver_id, sort_type }) {
      const params = { target_date: target_date, driver_id: driver_id, sort_type: sort_type }
      return new Promise((resolve) => {
        Vue.$http.put(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/sort_setting`, params).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
export default driver_schedule_sort_setting
